import { DemoVideoThumbail } from '@/constant/imgImport';
import {
  EVideoTabSectionKey,
  TEnterpriseProfileVideoTabSection,
} from '@/interfaces/enterprise-profile/video_tab.interface';

export const hashVideoSectionName = {
  [EVideoTabSectionKey.Videos]: 'Danh sách video',
};

export const iniTialVideo = {
  thumbnail: DemoVideoThumbail,
  title: 'Một ngày tại trường Đại học Y dược TPHCM',
  content:
    'Việc thu thập dữ liệu chủ yếu trên Doccen.vn bao gồm: email, điện thoại, tên đăng nhập, mật khẩu đăng nhập (thành viên). Đây là các thông tin mà Doccen.vn cần thành viên cung cấp bắt buộc khi đăng ký sử dụng dịch vụ để Doccen.vn liên hệ xác nhận khi khách hàng đăng ký sử dụng dịch vụ trên website',
  videoUrl: 'https://www.dofactory.com/media/movie.mp4',
  createdAt: new Date().toISOString(),
};

export const defaultVideoSection: TEnterpriseProfileVideoTabSection = [
  {
    sectionName: hashVideoSectionName[EVideoTabSectionKey.Videos],
    sectionKey: EVideoTabSectionKey.Videos,
    elements: {
      videos: [iniTialVideo],
    },
    isActive: true,
  },
];
